import { useFormikContext } from 'formik';
import { get } from 'lodash';

import { Box } from '@hivebrite/design-system/Box';

import { Row } from 'hb-react/shared/components/DesignSystem/Grid';
import {
  Select,
  Text,
} from 'hb-react/shared/components/formik/components/inputs';

import { StyledCol } from '../Layout';

const ShippingAddressForm = ({ userFieldsConfig }) => {
  const { values } = useFormikContext<{
    receipt: {
      address_type: string;
    };
  }>();

  const getPostalPlaceholder = (addressType, field) =>
    get(userFieldsConfig, `postal_${addressType}_${field}_placeholder`);

  return (
    <Box data-testid="shipping-address-form" display="block">
      <Box my={5} font="h4-semibold">
        {s__('NetworkEvents|Enter shipping address details')}:
      </Box>
      <Row>
        <StyledCol>
          <Text
            id="receipt[shipping_address_attributes][full_name]"
            name="receipt[shipping_address_attributes][full_name]"
            label={s__('NetworkEvents|Full name')}
            placeholder={s__('NetworkEvents|Full name')}
            validate={{ required: true }}
          />
        </StyledCol>
      </Row>
      <Row>
        <StyledCol>
          <Text
            id="receipt[shipping_address_attributes][address_1]"
            name="receipt[shipping_address_attributes][address_1]"
            label={I18n.t(
              'web.networks.events.receipt.billing_location.address_1',
            )}
            placeholder={
              getPostalPlaceholder(values.receipt.address_type, 'address_1') ||
              I18n.t('web.networks.events.receipt.billing_location.address_1')
            }
            validate={{ required: true }}
          />
        </StyledCol>
        <StyledCol>
          <Text
            id="receipt[shipping_address_attributes][address_2]"
            name="receipt[shipping_address_attributes][address_2]"
            label={I18n.t(
              'web.networks.events.receipt.billing_location.address_2',
            )}
            placeholder={
              getPostalPlaceholder(values.receipt.address_type, 'address_2') ||
              I18n.t('web.networks.events.receipt.billing_location.address_2')
            }
          />
        </StyledCol>
      </Row>
      <Row>
        <StyledCol>
          <Text
            id="receipt[shipping_address_attributes][address_3]"
            name="receipt[shipping_address_attributes][address_3]"
            label={I18n.t(
              'web.networks.events.receipt.billing_location.address_3',
            )}
            placeholder={
              getPostalPlaceholder(values.receipt.address_type, 'address_3') ||
              I18n.t('web.networks.events.receipt.billing_location.address_3')
            }
          />
        </StyledCol>

        <StyledCol>
          <Text
            id="receipt[shipping_address_attributes][city]"
            name="receipt[shipping_address_attributes][city]"
            placeholder={s__('NetworkEvents|City')}
            label={s__('NetworkEvents|City')}
            validate={{ required: true }}
          />
        </StyledCol>
      </Row>
      <Row>
        <StyledCol>
          <Text
            id="receipt[shipping_address_attributes][state]"
            name="receipt[shipping_address_attributes][state]"
            placeholder={s__('NetworkEvents|State')}
            label={s__('NetworkEvents|State')}
          />
        </StyledCol>
        <StyledCol>
          <Text
            id="receipt[shipping_address_attributes][postal_code]"
            name="receipt[shipping_address_attributes][postal_code]"
            placeholder={s__('NetworkEvents|Postal code')}
            label={s__('NetworkEvents|Postal code')}
            validate={{ required: true }}
          />
        </StyledCol>
      </Row>

      <Row>
        <StyledCol>
          <Select
            type="countries"
            name="receipt[shipping_address_attributes][country]"
            placeholder={I18n.t(
              'web.networks.events.receipt.billing_location.country',
            )}
            label={I18n.t(
              'web.networks.events.receipt.billing_location.country',
            )}
            inputHtml={{
              maxMenuHeight: 160,
            }}
            validate={{ required: true }}
          />
        </StyledCol>
      </Row>
    </Box>
  );
};

export default ShippingAddressForm;
